import React from 'react';
import Button, { ButtonVariants } from '@pixum/button';
import { Checkbox } from '@pixum/web-checkbox';
import { EmailInput } from '@pixum/web-input';

interface EmailCaptureFormProps {
  email: string;
  newsletterChecked: boolean;
  hasError: boolean;
  errorMessage?: string;
  isPending: boolean;
  constants: Record<string, string>;
  onEmailChange: (email: string) => void;
  onNewsletterChange: () => void;
  onFocus: () => void;
  action: (data: FormData) => void;
}

/**
 * Email capture form for voucher campaign.
 * Handles email input, newsletter checkbox, and form submission.
 *
 * Uses React's useActionState pattern with Server Actions:
 * - Controlled inputs for immediate UX (error clearing on focus)
 * - name attributes populate FormData for Server Action
 * - Progressive enhancement via action prop
 */
export function EmailCaptureForm({
  email,
  newsletterChecked,
  hasError,
  errorMessage,
  isPending,
  constants,
  onEmailChange,
  onNewsletterChange,
  onFocus,
  action
}: EmailCaptureFormProps) {
  const newsletterCheckboxId = React.useId();

  return (
    <form className="download-voucher-campaign__form" action={action}>
      {/* Hidden input carries the newsletter value into FormData for the Server Action */}
      <input type="hidden" name="newsletter" value={newsletterChecked ? 'on' : ''} />
      <Checkbox
        key={`newsletter-${newsletterChecked}`}
        checked={newsletterChecked}
        dataId="voucher-newsletter-checkbox"
        id={newsletterCheckboxId}
        label={constants.newsletterLabel}
        onChange={onNewsletterChange}
      />

      <EmailInput
        name="email"
        autoComplete="email"
        hasError={hasError}
        inputInfo={errorMessage}
        label={constants.emailLabel}
        onChange={e => onEmailChange(e.target.value)}
        onFocus={onFocus}
        value={email}
      />
      <Button isBusy={isPending} label={constants.submitButtonGetVoucher} variant={ButtonVariants.STRONG}>
        {constants.submitButtonGetVoucher}
      </Button>
    </form>
  );
}
